import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Outreach from './icon-outreach.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Outreach {...validProps} />;
}
SvgComponent.iconName = 'outreach';

/**
 * @deprecated This is a legacy icon
 */
export const OutreachIcon = svgIconWrapper(SvgComponent);
